import axios from "axios";
import { useInfiniteQuery } from "react-query";
import { useRecoilValue } from "recoil";
import { BASE_PATH, HeadersInfo } from "../../../../../api/api";
import {
  langCodeState,
  searchState,
  userInfoProps,
  userInfoState
} from "../../../../../atoms/atom";

export interface IPostContent {
  admin_icon: string;
  admin_flag: number;
  comment_count: number;
  content: string;
  created_at: string;
  idx: number;
  images: [];
  language: string;
  like_count: number;
  nickname: string;
  section: number;
  service_code: string;
  status: number;
  title: string;
  updated_at: string;
  user_id: string;
  user_ip: string;
  user_like_status: number;
}

interface IProps {
  service_code: string | undefined;
  sectionTItle: string;
}

export const useInfiniteScrollQuery = (props: IProps) => {
  const { service_code, sectionTItle } = props;
  const searchVal = useRecoilValue(searchState);
  const langCode = useRecoilValue(langCodeState);
  const userInfo = useRecoilValue(userInfoState);

  const getPageBoard = async ({
    pageParam = 1,
    title = sectionTItle,
    search = searchVal
  }) => {
    const res = await axios.get(
      `${BASE_PATH}/vfunlounge/posts/${service_code}/${title}?lang=${langCode}&page=${pageParam}&search=${search}`,
      HeadersInfo(
        userInfo.Ssoinfo,
        userInfo.Userid,
        userInfo.Userbirth,
        userInfo.channelingType,
        "application/json"
      )
    );

    return {
      result: res.data.result,
      boardpage: res.data.result === 1 ? res.data.data.data : "",
      currentpage: res.data.result === 1 ? res.data.data.current_page : 0,
      total: res.data.result === 1 ? res.data.data.total : 0,
      isLast:
        res.data.result === 1
          ? res.data.data.current_page === res.data.data.last_page
            ? true
            : false
          : false
    };
  };

  const {
    data: getBoard,
    fetchNextPage: getNextPage,
    isSuccess: getBoardIsSuccess,
    hasNextPage: getNextPageIsPossible
  } = useInfiniteQuery(
    ["page_board_list", sectionTItle, searchVal, langCode],
    getPageBoard,
    {
      getNextPageParam: (lastPage, pages) => {
        // lastPage와 pages는 콜백함수에서 리턴한 값을 의미한다!!
        // lastPage: 직전에 반환된 리턴값, pages: 여태 받아온 전체 페이지
        if (!lastPage.isLast) {
          return lastPage.currentpage + 1;
        }
        // 마지막 페이지면 undefined가 리턴되어서 hasNextPage는 false가 됨!
        return undefined;
      }
    }
  );

  return { getBoard, getNextPage, getBoardIsSuccess, getNextPageIsPossible };
};

interface deleteProps {
  service_code: string | undefined;
  title: string | undefined;
  idx: number;
  userInfo: userInfoProps;
}

export const DeleteApi = async (props: deleteProps) => {
  const { service_code, title, idx, userInfo } = props;

  const res = await axios.delete(
    `${BASE_PATH}/vfunlounge/posts/${service_code}/${title}/${idx}`,
    HeadersInfo(
      userInfo.Ssoinfo,
      userInfo.Userid,
      userInfo.Userbirth,
      userInfo.channelingType,
      "application/json"
    )
  );

  return res;
};
